/**
 * Layout
 */

import {getRootVar} from '../../shared/utils';

import SelectorEngine from '../../shared/dom/selector-engine';

import header from './header';
import menu from './menu';
import footer from './footer';
import search from './search';
import section from './main/section';

import Jumplist from '../../shared/components/jumplist';
import Manipulator from '../../shared/dom/manipulator';
import EventHandler from '../../shared/dom/event-handler';
import Data from '../../shared/dom/data';

/**
 * Sprungliste die einer Seite ´global´ hinzugefügt wurde.
 */
const pageJumplist = () => {
	const originalDocTitle = document.title;
	const originalDocUrl   = location.href;
	const pageJumplist     = SelectorEngine.findOne('#page-jumplist');

	if(pageJumplist) {
		const apiPageJumplist = Jumplist.init(pageJumplist, {
			windowMode: true, // Diese Jumplist ´behandelt´ das Window-Objekt!
			onInit: (event, foo) => {
				const _element   = event.target;
				const _container = SelectorEngine.findOne('.jumplist__container', _element);
				const _menu = SelectorEngine.findOne('.jumplist-menu', _container);
				const _headerTpl = Manipulator.createElementFrom('<div class="jumplist-header"/>');
				const _spinnerTpl = Manipulator.createElementFrom('<div class="jumplist-spinner spinner"/>');
				const _title     = Manipulator.createElementFrom('<div class="title">Seiteninhalte</div>');
				const _toggle    = Manipulator.createElementFrom('<div class="toggle"><i class="fa-regular fa-chevron-down"></i></div>');

				Manipulator.elementAppend(_spinnerTpl, _container);

				const toggleMenu = () => {
					if (Data.get(_element, `ifab.jumplist.show`)) {
						Data.set(_element, `ifab.jumplist.show`, false);
						_menu.classList.remove('-show');
						_toggle.classList.remove('-active');

					} else {
						Data.set(_element, `ifab.jumplist.show`, true);
						_menu.classList.add('-show');
						_toggle.classList.add('-active');
					}
				};

				EventHandler.on(_toggle, 'click', () => {
					toggleMenu();
				});

				Manipulator.elementAppend(_title, _headerTpl);
				Manipulator.elementAppend(_toggle, _headerTpl);
				Manipulator.elementPrepend(_headerTpl, _container);

				setTimeout(() => {
					_spinnerTpl.remove();
					toggleMenu();
				}, 700);
			},
			onNavigate: (event) => {
				//
				// ´Scroll top offset´ dem Zielbereich zuweisen.
				// Somit verschwindet er nicht visuell unter der Jumplist.
				//

				// const sto = parseInt(getRootVar('global-scroll-top-offset') || 0, 10);
				// const jlh = pageJumplist.offsetHeight;
				//
				// event.section.style.scrollMarginTop = `${jlh + sto}px`;

				//
				// Dokumenetentitel, -URL und Historieaktualisieren.
				//

				const newDocTitle = `${originalDocTitle} (${event.link.jumplistText})`;
				const historyUrl  = location.hash ? `${originalDocUrl.split('#')[0]}${event.link.jumplistHash}` : `${location.href.split('#')[0]}${event.link.jumplistHash}`;

				// Seitentitel aktualisieren.
				document.title = newDocTitle;

				// History aktualsieren.
				history.pushState({
					section: event.section.jumplistHash,
					title  : newDocTitle
				}, '', historyUrl);
			}
		});

		if (location.hash) {
			apiPageJumplist.activate(location.hash);
		}
	}
};

const initPageBackdrop = (state) => {
	const element = SelectorEngine.findOne('#page-backdrop');

	if(state) {
		Manipulator.addClass(element, '-is-visible');
	} else {
		Manipulator.removeClass(element, '-is-visible');
	}
};

// ------
// Public
// ------

const layout = () => {
	header();
	menu();
	footer();
	search();
	// section();

	// Sprungliste (hinzugefügt einer Seite)
	pageJumplist();
};

// Export
export {
	layout,
	initPageBackdrop
};
